import React from "react";
import { ForceGraph3D } from "react-force-graph";
import { useEffect } from "react";
import axios from "axios";
import { Spin } from "antd";

export default function Graph(props) {
  const [elements, setElements] = React.useState({ nodes: [], links: [] });
  const [fetching, setFetching] = React.useState(false);

  function buildQuery(filters) {
    return Object.keys(filters)
      .filter((k) => filters[k].some((v) => v))
      .flatMap((k) => filters[k].map((v) => `${k}=${v}`))
      .join("&");
  }

  const { show, filters, api, onRender } = props;

  useEffect(() => {
    if (show) {
      setFetching(true);
      let query = buildQuery(filters);
      axios.get(`${api}?${query}`).then((response) => {
        setFetching(false);
        setElements({ nodes: response.data.nodes, links: response.data.links });
        onRender();
      });
    }
  }, [setElements, show, api, filters, onRender]);

  let graph = React.createRef();

  function nodeValue(n) {
    let links = elements.links
        .filter((l) => l.target === n.id)
    
    let value = links.map(a => a.weight).reduce(function(a, b){
        return a + b;
      }, 1)

      return value
    }
    

  //const defaultLinkWidth = (w) => w;
  //const linkWidthFunction = props.linkWidth || defaultLinkWidth;
  //const linkWidth = (n) => linkWidthFunction(n.weight);

  return (
    elements.nodes.length > 0 && (
      <span>
        {fetching && <Spin size="large" />}
        {!fetching && (
          <ForceGraph3D
            graphData={elements}
            nodeAutoColorBy="type"
            nodeLabel="id"
            linkWidth={2}
            linkLabel="weight"
            nodeVal={nodeValue}
            onLinkClick={props.onLinkClick}
            ref={graph}
          />
        )}
      </span>
    )
  );
}
